/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlimitedpulsecredits2Inputs */

const en_unlimitedpulsecredits2 = /** @type {(inputs: Unlimitedpulsecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited Pulse Credits`)
};

const de_unlimitedpulsecredits2 = /** @type {(inputs: Unlimitedpulsecredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Pulse Credits`)
};

/**
* | output |
* | --- |
* | "Unlimited Pulse Credits" |
*
* @param {Unlimitedpulsecredits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unlimitedpulsecredits2 = /** @type {((inputs?: Unlimitedpulsecredits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlimitedpulsecredits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlimitedpulsecredits2(inputs)
	return de_unlimitedpulsecredits2(inputs)
});
export { unlimitedpulsecredits2 as "unlimitedPulseCredits" }